import DOMPurify from "dompurify";

export function sanitizeHtml(dirty: string): string {
  if (!dirty || typeof dirty !== "string") return "";

  // return DOMPurify.sanitize(dirty, {
  //   USE_PROFILES: {
  //     html: true,
  //   },
  // });

  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS: [
      "p",
      "br",
      "b",
      "i",
      "strong",
      "em",
      "ul",
      "ol",
      "li",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "a",
    ],
    ALLOWED_ATTR: ["href", "title", "target","rel"],
    FORBID_TAGS: ["script", "object", "embed", "style", "iframe", "form"],
    ALLOWED_URI_REGEXP: /^https?:\/\/.*/,
  });
}

export function sanitizeString(input: string): string {
  if (!input || typeof input !== "string") return "";

  let clean = DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true, // Keep text content but remove tags
  });

  clean =
    clean
      ?.replace(/&[#\w]+;/g, "") // Remove HTML entities like &lt; &gt; &amp;
      ?.replace(/<[^>]*>/g, "") // Remove any remaining HTML tags
      ?.replace(/[<>]/g, "") // Remove angle brackets
      ?.replace(/javascript:/gi, "") // Remove javascript: protocol
      ?.replace(/on\w+\s*=/gi, "") // Remove event handlers
      ?.replace(/data:/gi, "") // Remove data: protocol
      ?.replace(/vbscript:/gi, "") // Remove vbscript: protocol
      ?.trim() ?? "";

  return clean;
}

export function isSafeString(input: string): boolean {
  if (!input || typeof input !== "string") return true;

  const clean = DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });
  const isValid = input === clean;
  return isValid;
}

export function validateXSSSafe(input: string): boolean {
  if (!input || typeof input !== "string") return true;

  const xssPatterns = [
    /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
    /javascript:/gi,
    /on\w+\s*=/gi,
    /<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi,
    /<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi,
    /<embed\b[^<]*(?:(?!<\/embed>)<[^<]*)*<\/embed>/gi,
    /vbscript:/gi,
    /data:text\/html/gi,
  ];

  return !xssPatterns.some((pattern) => pattern.test(input));
}

export function sanitizeUrl(url: string): string | null {
  try {
    if (!url || typeof url !== "string") return null;

    const urlObj = new URL(url);
    // Only allow http and https protocols
    if (!["http:", "https:"].includes(urlObj.protocol)) {
      return null;
    }
    return DOMPurify.sanitize(url);
  } catch {
    return null;
  }
}

export const isValidUrl = (url: string): boolean => {
  if (!url) return false;

  try {
    const urlObj = new URL(url);
    // const allowedDomains = [
    //   'app.geta.ai',
    //   'api.geta.ai',
    //   'reports.geta.ai',
    //   'cdn.geta.ai'
    // ];

    // return urlObj.protocol === 'https:' &&
    //        allowedDomains.some(domain =>
    //          urlObj.hostname === domain || urlObj.hostname.endsWith('.' + domain)
    //        );

    return urlObj.protocol === "https:";
  } catch {
    return false;
  }
};

export const safeWindowOpen = (url: string): void => {
  if (!isValidUrl(url)) {
    console.error("Blocked potentially malicious URL:", url);
    alert(
      "Invalid URL detected. For security reasons, this link has been blocked."
    );
    return;
  }

  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) {
    newWindow.opener = null;
  }
};
